var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSettings = function SvgIcoSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.82 2a1 1 0 0 0-.98.804L9.521 4.39a8 8 0 0 0-1.15.477l-1.347-.899a1 1 0 0 0-1.262.125l-1.669 1.67a1 1 0 0 0-.125 1.261l.899 1.348a8 8 0 0 0-.477 1.149l-1.587.317a1 1 0 0 0-.804.98v2.361a1 1 0 0 0 .804.98l1.587.318q.196.598.477 1.15l-.899 1.347a1 1 0 0 0 .125 1.261l1.67 1.67a1 1 0 0 0 1.261.125l1.348-.899q.551.282 1.149.477l.317 1.587a1 1 0 0 0 .98.804h2.361a1 1 0 0 0 .98-.804l.318-1.587a8 8 0 0 0 1.15-.477l1.347.898a1 1 0 0 0 1.261-.125l1.67-1.669a1 1 0 0 0 .125-1.261l-.899-1.348q.282-.551.477-1.149l1.587-.317a1 1 0 0 0 .804-.98V10.82a1 1 0 0 0-.804-.98l-1.587-.318a8 8 0 0 0-.477-1.15l.898-1.347a1 1 0 0 0-.124-1.262l-1.67-1.669a1 1 0 0 0-1.261-.125l-1.348.899a8 8 0 0 0-1.149-.477l-.317-1.587A1 1 0 0 0 13.18 2zM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcoSettings;